// extracted by mini-css-extract-plugin
export default {"k":"l2_k__N3b-+","active":"l2_active__wkhmK"};